module.exports = __webpack_public_path__ + "img/hw-bg5.f7c67f8f.png";